/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Auth, getBearerToken } from "../Authentication/Auth";
import {
  convertDifferenceFromADateIntoDays,
  decryptValue,
  hashSections,
  hashSectionsAs,
  isEmptyObject,
  labels,
  metamaskErrorMessages,
  notificationPosition,
  notificationSetting,
  notificationType,
  notUndefined,
  reasons,
  routesList,
  showNotification,
  superBabiesTypes,
} from "../Common";
import { SwitchLoader } from "../Common/AxiosConfiguration";
import { loaderType, StartLoader, StopLoader } from "../Common/Loader";
import { GlobalModal } from "../Global";
import useWalletChange from "../hooks/useWalletChange";
import { CommonLoader } from "../Loaders";
import {
  connectWallet,
  getBabyBalanceOf,
  getBabyTotalValues,
  getRequiredTokenForSuperBabies,
  getWalletOfOwnerBaby,
  mintNFTSuperBaby,
  publicSaleStatusBaby,
} from "../Scripts/interact";
import { BabyMintingService } from "../Services";
import { MintButton } from "../SubSection/MintButton";
import { Link } from "react-router-dom";

const SuperBabyMint = () => {
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [walletOfOwnerBaby, setWalletOfOwnerBaby] = useState([]);
  const [totalValuesOfBaby, setTotalValuesOfBaby] = useState({});
  const [babyBalanceOf, setBabyBalanceOf] = useState();
  const [requiredTokenForSuperBabies, setRequiredTokenForSuperBabies] =
    useState();
  const [isBabyPublicSaleOn, setIsBabyPublicSaleOn] = useState(false);
  const [saleStartedOn, setSaleStartedOn] = useState();
  const [filteredSuperBabies, setFilteredSuperBabies] = useState([]);
  const [selectedSuperBabies, setSelectedSuperBabies] = useState({
    [superBabiesTypes.AIR]: null,
    [superBabiesTypes.EARTH]: null,
    [superBabiesTypes.FIRE]: null,
    [superBabiesTypes.SPACE]: null,
    [superBabiesTypes.WATER]: null,
  });
  const [mintedSuperBabiesList, setMintedSuperBabiesList] = useState([]);
  const [merkleData, setMerkleData] = useState({});
  const [modal, setModal] = useState({
    superBabyModal: false,
    videoModal: false,
  });
  const [isVideoVisible, setIsVideoVisible] = useState(false);
  const [displayCloseButton, setDisplayCloseButton] = useState(false);
  const [openSeaClass, setOpenSeaClass] = useState("assets/images/opensea.png");
  const { isWalletConnected, changedAddress } = useWalletChange();
  const quantity = 1;
  const totalEthers = 0;
  const unmount = useRef();
  const videoRef = useRef();
  const env = process.env.NODE_ENV;

  // const changedAddress = "0x3f977a8ea5ffaddd655ce4b5e4c2417fdce08dde"; //For Testing
  // const changedAddress = "0x72D6e4e54903FEE22f5BcaA7bBD01917d39c2cF8"; //For Testing

  // When Wallet is Connected
  useEffect(() => {
    if (isWalletConnected) {
      SwitchLoader(loaderType.COMMON, "Please Wait");
      handleLogin();
    }
  }, [isWalletConnected]);

  // When User Changes The Address or Initiate
  useEffect(() => {
    const checkUndefinedAddress = async () => {
      if (notUndefined(changedAddress)) {
        handleNodeLogin();
        getBabyWalletofOwnerDetails();
        getRequiredTokenForSuperBaby();
        getBabyPublicSaleStatus();
        const totalValues = await getBabyTotalValuesFromContract();
        getBabyBalanceOfFromContract();
      }
    };

    checkUndefinedAddress().catch(console.error);
    return () => {
      unmount.current = true;
    };
  }, [changedAddress]);

  // When User Logs in to the Server
  useEffect(() => {
    const getAndSetData = async () => {
      if (
        notUndefined(changedAddress) &&
        notUndefined(getBearerToken().bearerToken)
      ) {
        getAddressMerkleHash();
        getSuperBabyMintedList();
      }
    };
    getAndSetData().catch(console.error);
  }, [changedAddress, getBearerToken().bearerToken]);

  // On Selection of Super Baby Check Eligibility For Minting
  useEffect(() => {
    checkForMint();
  }, [selectedSuperBabies]);

  /* Handlers */
  //Function to Connect Wallet
  const connectWalletPressed = async () => {
    const response = await connectWallet();

    if (response.status) {
      console.log("Wallet Connected");
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };
  // Function to Open Specific Modal
  const handleModalOpen = (modalName, ...rest) => {
    let keyName = "";
    switch (true) {
      case modalName === "super_baby_modal":
        keyName = "superBabyModal";
        break;
      case modalName === "video_modal":
        keyName = "videoModal";
        break;
      default:
        keyName = "";
    }
    if (keyName !== "") {
      setModal({ ...modal, [keyName]: true });
    }
  };

  // Function to Close Specific Modal
  const handleModalClose = (modalName) => {
    let keyName = "";
    switch (true) {
      case modalName === "super_baby_modal":
        keyName = "superBabyModal";
        break;
      case modalName === "video_modal":
        keyName = "videoModal";
        window.location.reload();
        break;
      default:
        keyName = "";
    }
    if (keyName !== "") {
      setModal({ ...modal, [keyName]: false });
    }
  };

  const playVideo = () => {
    if (notUndefined(videoRef.current)) {
      console.log("Video Ref: ", videoRef.current);
      videoRef.current.play();
    }
  };

  const clearAllTokens = () => {
    let superBabies = selectedSuperBabies;
    Object.keys(superBabies).forEach((key) => {
      superBabies[key] = null;
    });

    setSelectedSuperBabies(superBabies);
  };
  /* Getters */
  /**
   * Function to Fetch Wallet of Baby
   * @returns {Object}response
   * @comment Use Array from response named wallet
   */
  const getBabyWalletofOwnerDetails = async () => {
    const response = await getWalletOfOwnerBaby(changedAddress);
    console.log("Wallet of Baby Owner By Contract: ", response);
    if (response?.status) {
      if (notUndefined(response?.wallet) && response?.wallet.length > 0) {
        // console.log("Child Wallet: ",response)
        setWalletOfOwnerBaby(response?.wallet);
        return response?.wallet;
      } else {
        return [];
      }
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  /**
   * Function to Return Total Values of Baby
   * @returns {Object}response
   * @comment Use {totalSupply, maxGenCount, maxPerMintToken} from response
   */
  const getBabyTotalValuesFromContract = async () => {
    const response = await getBabyTotalValues();

    if (response?.status) {
      setTotalValuesOfBaby({
        totalSupply: response?.totalSupply,
        maxGenCount: response?.maxGenCount,
        maxPerMintToken: response?.maxPerMintToken,
      });
      return response;
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  /**
   * Function to Return Required Tokens For Super Baby Minting
   * @returns {Object}response
   * @comment Field requireTokens i.e. a number e.g. 5 or 7 etc
   */
  const getRequiredTokenForSuperBaby = async () => {
    const response = await getRequiredTokenForSuperBabies();

    if (response?.status) {
      setRequiredTokenForSuperBabies(response?.requireTokens);
      return response;
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  /**
   * Function to Return Baby Public Sale Status
   * @returns {Object}response
   * @comment Field publicSale i.e. a boolean e.g. true/false
   */
  const getBabyPublicSaleStatus = async () => {
    const response = await publicSaleStatusBaby();
    if (response?.status) {
      setIsBabyPublicSaleOn(response?.publicSale);
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  /**
   * Function to Get Balance of Baby
   * @returns {Object}response
   * @comment Use {balance} from response
   */
  const getBabyBalanceOfFromContract = async () => {
    const response = await getBabyBalanceOf(changedAddress);
    console.log("Baby Balance Of:", response);
    if (response?.status) {
      setBabyBalanceOf(response?.balance);
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  /**
   * API Function to Return Specific Type Super Baby Tokens
   * @returns {Object}response
   */
  const getSuperBabiesToken = async (baby_type) => {
    SwitchLoader(loaderType.COMMON, "Please Wait, Super Babies Coming");
    let allTokens = await BabyMintingService.getSuperBabyToken({
      wallet_address: changedAddress,
      type: baby_type,
    }).then((response) => {
      if (response?.status === false) {
        showNotification(
          notificationType.DANGER,
          metamaskErrorMessages.typeTokensNotFound,
          notificationSetting
        );
      } else if (response?.status === true) {
        setSuperBabyTokens(response?.data);
        return response?.data;
      }
    });

    return allTokens;
  };

  //Check That Specific Token Exist in Wallet or Not
  const checkTokenExist = (tokenId) => {
    return walletOfOwnerBaby.indexOf(parseInt(tokenId)) === -1
      ? env === "development"
      : true;
  };

  // Function to Check Eligibility for Minting
  const checkForMint = () => {
    const isEligibleForMint = Object.values(selectedSuperBabies).every(
      (value) =>
        value !== null &&
        typeof value === "object" &&
        !isEmptyObject(value) &&
        notUndefined(value.token_id) &&
        parseInt(value?.token_id) !== 0
    );

    if (isEligibleForMint) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  };

  /* Setters */
  //Process Filtering Data after Response and Set it
  const setSuperBabyTokens = (allTokens) => {
    // Previous Logic, Only Filter Tokens That Exist in wallet
    let filtered = allTokens.filter((token) => {
      return checkTokenExist(token.token_id);
    });

    //Current Logic, Tokens That is Greater Than 90 Days is Eligible
    let readyForSet = filtered.map((token) => {
      let tempObj = {
        isEligibleForMint: false,
        reason: reasons.NOT_EXIST_IN_WALLET,
        days: 0,
      };
      let dateDifference = convertDifferenceFromADateIntoDays(
        token?.txdatetime
      );

      switch (true) {
        case checkTokenExist(token?.token_id):
          switch (true) {
            case token?.availabletoselect:
              tempObj = {
                isEligibleForMint: token?.availabletoselect,
                reason: reasons.ABOVE_EQUAL_90,
              };
              break;
            default:
              tempObj = {
                ...tempObj,
                reason: reasons.BELOW_90,
                days: token?.remainingDays,
              };
          }
          break;
        default:
      }
      return {
        ...token,
        ...tempObj,
        days: dateDifference,
      };
    });

    // console.log("filtered",filtered)
    if (readyForSet.length > 0) {
      setFilteredSuperBabies(readyForSet);
      handleModalOpen("super_baby_modal");
    } else {
      showNotification(
        notificationType.DANGER,
        metamaskErrorMessages.typeTokensNotFound,
        notificationSetting
      );
    }
  };

  //Login to Our Server to Fetch All Tokens
  const handleLogin = () => {
    let newForm = {
      email: process.env.REACT_APP_API_LOGIN_UNAME,
      password: process.env.REACT_APP_API_LOGIN_PWD,
    };
    BabyMintingService.getServerLogin({ ...newForm }).then((response) => {
      if (response?.status === false) {
        showNotification(
          notificationType.DANGER,
          response.message,
          notificationSetting
        );
      } else if (response?.status === true) {
        Auth.authenticateServerData(response?.token);
        // setServerToken(response?.token);
        // setSaleStartedOn(response?.sale_start_on);
        // setCurrentDay(response?.data?.currentday);
      }
    });
  };

  //Login to Node Server to Generate Merkle Hash
  const handleNodeLogin = () => {
    let newForm = {
      username: process.env.REACT_APP_NODE_LOGIN_UNAME,
      secret: process.env.REACT_APP_NODE_LOGIN_SECRET,
    };
    BabyMintingService.getSuperBabyNodeLogin({ ...newForm }).then(
      (response) => {
        if (response?.status === false) {
          showNotification(
            notificationType.DANGER,
            response.message,
            notificationSetting
          );
        } else if (response?.status === true) {
          Auth.authenticateSuperBabyNodeData(response?.access_token);
        }
      }
    );
  };

  //Fetch Merkle Hash After Node Login
  const getAddressMerkleHash = () => {
    setMerkleData({});
    BabyMintingService.generateSuperBabyAddressHash({
      // wallet_address: "0x60Ac67b3a98CbEEC24B489603cFF65EdaBf138E8",
      wallet_address: changedAddress,
    }).then((response) => {
      if (response?.status === false) {
        showNotification(
          notificationType.DANGER,
          response.message,
          notificationSetting
        );
        StopLoader(loaderType.BUTTON);
        // setButtonDisabled(false);
      } else if (response?.status === true) {
        const decryptedRootHash = decryptValue(response?.rootHash);
        const decryptedAddressHash = decryptValue(response?.hashProof).split(
          ","
        );

        setMerkleData({
          merkleHash: decryptedAddressHash,
          rootHash: decryptedRootHash,
        });
      }
    });
  };

  //Fetch Merkle Hash After Node Login
  const getSuperBabyMintedList = () => {
    setMintedSuperBabiesList([]);
    SwitchLoader(loaderType.COMMON, "Please Wait, While Fetching List");
    BabyMintingService.getSuperBabyMintedList({
      wallet_address: changedAddress,
    }).then((response) => {
      if (response?.status === false) {
        showNotification(
          notificationType.DANGER,
          response.message,
          notificationSetting
        );
        StopLoader(loaderType.BUTTON);
        // setButtonDisabled(false);
      } else if (response?.status === true) {
        setMintedSuperBabiesList(response?.data);
      }
    });
  };

  //Mint Super Baby Here
  const mintSuperBabyNFTPressed = async (event) => {
    event.preventDefault();
    let mint_id;
    let filteredArray = [];
    if (
      parseInt(totalValuesOfBaby.maxPerMintToken) <
      parseInt(babyBalanceOf) + 1
    ) {
      showNotification(
        notificationType.DANGER,
        `Limit Exceed to Mint tokens As You've Already Minted ${parseInt(
          babyBalanceOf
        )} Tokens and The Limit is ${parseInt(
          totalValuesOfBaby.maxPerMintToken
        )}`,
        notificationSetting
      );
      return;
    }
    Object.values(selectedSuperBabies).every((value) =>
      filteredArray.push(value?.token_id)
    );

    let filteredArrayString = filteredArray.toString();
    if (filteredArray.length < 5) {
      showNotification(
        notificationType.DANGER,
        "Minimum 5 Tokens Required to Perform this action",
        notificationSetting
      );
      return;
    }

    let isEligible = await checkTokensEligibility(filteredArrayString);

    if (isEligible) {
      StartLoader(loaderType.BUTTON);
      setButtonDisabled(true);
      if (!isEmptyObject(merkleData) && notUndefined(merkleData?.merkleHash)) {
        mint_id = await addMintEntry(filteredArrayString);
        if (notUndefined(mint_id)) {
          StartLoader(loaderType.BUTTON);
          setButtonDisabled(true);
          const { status, message, hash } = await mintNFTSuperBaby(
            quantity,
            totalEthers,
            filteredArray.slice(0, requiredTokenForSuperBabies),
            merkleData?.merkleHash
          );
          if (status) {
            StopLoader(loaderType.BUTTON);
            setButtonDisabled(false);
            showNotification(notificationType.SUCCESS, message, {
              title: "Minting Successful",
              duration: 6000,
              notificationPosition: notificationPosition.BOTTOM_RIGHT,
            });

            let babyTokens = await getBabyWalletofOwnerDetails();
            if (babyTokens.length > 0) {
              let latestBabyToken = babyTokens[babyTokens.length - 1];
              manageMintEntry(
                "UPDATE",
                mint_id,
                filteredArrayString,
                hash,
                latestBabyToken
              );
            }
          } else {
            StopLoader(loaderType.BUTTON);
            setButtonDisabled(false);
            console.error(message);
            showNotification(
              notificationType.DANGER,
              message,
              notificationSetting
            );

            manageMintEntry("DELETE", mint_id, filteredArrayString, hash, 0);
          }
        }
      } else {
        StopLoader(loaderType.BUTTON);
        setButtonDisabled(false);
        showNotification(
          notificationType.DANGER,
          "Hash is Not Available for this Wallet Address",
          notificationSetting
        );
        getAddressMerkleHash();
      }
    }
  };

  //Check Super Baby Tokens Available For Mint
  const checkTokensEligibility = async (token_ids) => {
    let status = false;
    unmount.current = false;
    SwitchLoader(loaderType.COMMON, "Please Wait, While Authorizing");
    await BabyMintingService.checkSuperBabyTokensAvailable({
      wallet_address: changedAddress,
      token_id: token_ids,
    }).then((response) => {
      if (unmount.current === true) return;
      if (response.status) {
        status = true;
      } else {
        showNotification(
          notificationType.ERROR,
          response.message,
          notificationSetting
        );
      }
    });
    // console.log("ID:", mint_id);
    return status;
  };

  // Add Mint Entry to DB Before Minting
  const addMintEntry = async (type_token_arr) => {
    let mint_id;
    let tempObject = {
      wallet_address: changedAddress,
      // wallet_address: "0x60Ac67b3a98CbEEC24B489603cFF65EdaBf138E8",
      type_token_arr: type_token_arr,
      count: quantity,
      status: 0,
      txn_hash: "",
    };
    unmount.current = false;
    await BabyMintingService.addSuperBabyMint(tempObject).then((response) => {
      if (unmount.current === true) return;
      if (response.status) {
        mint_id = response?.data?.minted?.mint_id;
      } else {
        setButtonDisabled(false);
        showNotification(
          notificationType.ERROR,
          response.message,
          notificationSetting
        );
        mint_id = "";
      }
    });
    // console.log("ID:", mint_id);
    return mint_id;
  };

  const manageMintEntry = (
    operationType,
    mint_id,
    type_token_arr,
    txnHash,
    baby_no
  ) => {
    // let status;
    let tempObject = {
      wallet_address: changedAddress,
      // wallet_address: "0x60Ac67b3a98CbEEC24B489603cFF65EdaBf138E8",
      type_token_arr: type_token_arr,
      count: quantity,
      txn_hash: txnHash,
      status: operationType === "UPDATE" ? 1 : operationType === "DELETE" && 2,
      mint_id: mint_id,
      baby_no: baby_no,
    };

    unmount.current = false;
    BabyMintingService.addSuperBabyMint(tempObject).then((response) => {
      if (unmount.current === true) return;
      if (response.status) {
        // status = true;
        console.log(`Entry ${operationType}ed Hash:${txnHash} ID:${mint_id}`);
        if (operationType === "UPDATE") {
          handleModalOpen("video_modal");
          playVideo();
          // window.location.reload();
          // clearAllTokens();
        }
      } else {
        console.error("Error Adding Data : ", response.message);
        // if(response?.data?.baby_already_attached){

        // }
        setButtonDisabled(false);
        showNotification(
          notificationType.ERROR,
          response.message,
          notificationSetting
        );
        // status = false;
      }
      // getTokenType();
    });
  };

  //After Clicking A Baby From List, Set it to Group of 5
  const setSuperBabiesGroup = (superBaby, superBabyType) => {
    setSelectedSuperBabies({
      ...selectedSuperBabies,
      [superBabyType]: superBaby,
    });

    handleModalClose("super_baby_modal");
  };

  // Verify If Specific Type Baby is Selected then set it into block otherwise show message
  const checkSuperBabySelected = (superBabyType) => {
    let child;
    if (
      superBabyType !== "" &&
      notUndefined(selectedSuperBabies[superBabyType]) &&
      !isEmptyObject(selectedSuperBabies[superBabyType])
    ) {
      child = (
        <div className="media">
          <img
            src={selectedSuperBabies[superBabyType]?.image}
            className={"img-fluid"}
            alt=""
          />
        </div>
      );
    } else {
      child = (
        <>
          click here <br />
          to select
        </>
      );
    }
    return child;
  };

  // Set/Remove Active Class From Block on the Basis of Super Baby Selection
  const activeDeactiveSuperBabySelected = (superBabyType) => {
    return (
      superBabyType !== "" &&
      notUndefined(selectedSuperBabies[superBabyType]) &&
      !isEmptyObject(selectedSuperBabies[superBabyType])
    );
  };

  const showMintedSuperBabies = () => {
    let length = parseInt(mintedSuperBabiesList.length);
    let children = [...mintedSuperBabiesList];
    for (let i = 0; i < 3 - length; i++) {
      children.push({ id: 0, image: null });
    }

    let section = children.map((child, idx) => {
      return (
        <Fragment key={`minted-super-babies-${idx}`}>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="media_div">
              <img src="assets/images/minted-frame-neon.png" alt="" />
              {parseInt(child?.id) !== 0 ? (
                <div className="inner-img">
                  <img src={child?.image} alt="" />
                </div>
              ) : (
                <div className="inner-img">
                  {/* Due to Client's requirement, Animation will only show after minting the token, otherwise the section will remain blank */}
                  {/* <img
                    src="assets/images/super-baby-placeholder-animation.gif"
                    alt=""
                  /> */}
                </div>
              )}
            </div>
          </div>
        </Fragment>
      );
    });

    return section;
  };

  return (
    <>
      <div className={"superBabyNew"}>
        <header>
          <div className="container">
            <nav className="navbar navbar-expand-xl navbar-light">
              <a
                className={`nav-link closeSideBar navbar-brand`}
                aria-current="page"
                href={routesList.homePage}
              >
                <img src="assets/images/logo_flat.png" alt="" />
              </a>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <button
                  className="navbar-toggler collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  &times;
                </button>
                <ul className="navbar-nav ms-auto ">
                  <li className="nav-item">
                    <a
                      className={`nav-link closeSideBar`}
                      aria-current="page"
                      href={routesList.homePage}
                    >
                      Home
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link closeSideBar"
                      href={`${routesList.homePage}${hashSectionsAs.aboutUs}`}
                    >
                      About us
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link closeSideBar"
                      href={`${routesList.homePage}${hashSectionsAs.roadmap}`}
                    >
                      Roadmap
                    </a>
                  </li>
                  {/* <li className="nav-item">
                    <Link
                      className={`nav-link closeSideBar`} 
                      to={routesList.utilities}
                    >
                      {labels.utilities}
                    </Link>
                  </li>  */}
                  <li className="nav-item">
                    <a
                      className="nav-link closeSideBar"
                      href={`${routesList.homePage}${hashSectionsAs.team}`}
                    >
                      Team
                    </a>
                  </li>
                  <li className="nav-item social-icon-top">
                    <a
                      href={"https://twitter.com/SuperCreatorNFT"}
                      target="_blank"
                      rel="noreferrer"
                      className="closeSideBar"
                    >
                      <i className="bi bi-twitter"></i>
                    </a>
                    <a
                      href={"https://discord.gg/2XGJMR7sfw"}
                      target="_blank"
                      rel="noreferrer"
                      className="closeSideBar"
                    >
                      <i className="bi bi-discord"></i>
                    </a>
                    <a
                      href={
                        "https://opensea.io/collection/supercreatorsorigins"
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="closeSideBar opensea"
                      onMouseEnter={() =>
                        setOpenSeaClass("assets/images/opensea-hover.png")
                      }
                      onMouseLeave={() =>
                        setOpenSeaClass("assets/images/opensea.png")
                      }
                    >
                      <img src={openSeaClass} alt="" />
                    </a>
                    <a
                      href={"https://www.instagram.com/iamverseofficial/"}
                      target="_blank"
                      rel="noreferrer"
                      className="closeSideBar opensea"
                    >
                      <i className="bi bi-instagram"></i>
                    </a>
                  </li>
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link btn dropdown-toggle"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Token Holders
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                    >
                      {parseInt(
                        process.env.REACT_APP_BABY_MINTING_BUTTON_DISPLAY
                      ) === 1 && (
                        <li className="nav-item wallet">
                          <Link
                            className="closeSideBar" //onClick={mintNFT}>
                            to={routesList.baby_mint}
                          >
                            {labels.baby_mint}
                          </Link>
                        </li>
                      )}
                      {parseInt(
                        process.env.REACT_APP_SUPER_BABY_MINTING_BUTTON_DISPLAY
                      ) === 1 && (
                        <li className="nav-item wallet">
                          <Link
                            className="closeSideBar" //onClick={mintNFT}>
                            to={routesList.super_baby_mint}
                          >
                            {labels.super_baby_mint}
                          </Link>
                        </li>
                      )}
                      {parseInt(
                        process.env.REACT_APP_TOKEN_HOLDER_BUTTON_DISPLAY
                      ) === 1 && (
                        <li className="nav-item wallet">
                          <Link
                            className="closeSideBar" //onClick={mintNFT}>
                            to={routesList.token_holder}
                          >
                            {labels.token_holder_area}
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>

                  {/* {parseInt(process.env.REACT_APP_BABY_MINTING_BUTTON_DISPLAY) ===
                    1 && (
                    <li className="nav-item wallet me-2">
                      <Link
                        className="btn closeSideBar" //onClick={mintNFT}>
                        to={routesList.baby_mint}
                      >
                        <img
                          src="assets/images/baby.png"
                          alt="Baby Mint"
                          title=""
                          className="babymint-icon me-2"
                        />
                        {labels.baby_mint}
                      </Link>
                    </li>
                  )}
                  {parseInt(process.env.REACT_APP_TOKEN_HOLDER_BUTTON_DISPLAY) ===
                    1 && (
                    <li className="nav-item wallet">
                      <Link
                        className="btn closeSideBar" //onClick={mintNFT}>
                        to={routesList.token_holder}
                      >
                        {labels.token_holder_area}
                      </Link>
                    </li>
                  )} */}

                  {/* <li className="nav-item wallet">
                    {window.location.pathname === routesList.homePage && (
                      <Link
                        className="btn closeSideBar" //onClick={mintNFT}>
                        to={routesList.token_registration}
                      >
                        {labels.token_registration}
                      </Link>
                    )}
                    {!walletConnected ? (
                      <button
                        type="button"
                        className="btn closeSideBar"
                        onClick={connectWalletPressed}
                      >
                        {labels.connect_wallet}
                      </button>
                    ) : (
                      <Link
                        className="btn closeSideBar" //onClick={mintNFT}>
                        to={routesList.mint}
                      >
                        {labels.mint}
                      </Link>
                    )}
                  </li> */}
                </ul>
              </div>
            </nav>
          </div>
        </header>
        <section className="banner">
          <div className="container">
            <div className="row d-none d-lg-block ">
              <div className="col-lg-12 text-center">
                <div className="media_div logo_icon">
                  <img src="assets/images/icon-logo.png" alt="" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="row banner_content">
                  <div className="col-6 col-lg-6 col-md-6 col-xl-3 order-1 order-xl-1">
                    <div className="media_div">
                      {" "}
                      <img src="assets/images/super-baby1.png" alt="" />{" "}
                    </div>
                  </div>
                  <div className="col-lg-12 col-xl-6 order-3 order-xl-2">
                    <div className=" text-center">
                      <span>Welcome to the divine fusion chamber</span>
                      <h1>Super Babies</h1>
                      <p>
                        “ Gifted with special powers to enrich the lives of
                        others in the Meta and Physical world. ”
                      </p>
                      {isWalletConnected ? (
                        <p className="banner_button">
                          Wallet Address: {changedAddress}
                        </p>
                      ) : (
                        <a
                          className="banner_button clickable"
                          onClick={connectWalletPressed}
                        >
                          Connect Wallet
                        </a>
                      )}
                    </div>
                  </div>
                  <div className="col-6 col-lg-6 col-md-6 col-xl-3 order-2 order-xl-3">
                    <div className="media_div">
                      {" "}
                      <img src="assets/images/super-baby2.png" alt="" />{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row banner_mobile d-block d-lg-none ">
              <div className="col-lg-12 text-center">
                <div className="media_div logo_icon">
                  <img src="assets/images/icon-logo.png" alt="" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="row banner_content">
                  <div className="col-lg-12 col-xl-6 ">
                    <div className=" text-center">
                      <span className="mt-0">
                        Welcome to the divine fusion chamber
                      </span>
                      <h1 className="mt-0">Super Babies</h1>
                      <p>
                        “ Gifted with special powers to enrich the lives of
                        others in the Meta and Physical world. ”
                      </p>
                    </div>
                  </div>
                  <div className="col-6 col-lg-6 col-md-6 col-xl-3 justify-content-end ">
                    <div className="media_div text-end">
                      {" "}
                      <img src="assets/images/super-baby1.png" alt="" />{" "}
                    </div>
                  </div>
                  <div className="col-6 col-lg-6 col-md-6 col-xl-3 justify-content-start">
                    <div className="media_div text-start">
                      {" "}
                      <img src="assets/images/super-baby2.png" alt="" />{" "}
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className=" text-center mt-5">
                      {isWalletConnected ? (
                        <p className="banner_button">
                          Wallet Address: {changedAddress}
                        </p>
                      ) : (
                        <a
                          className="banner_button clickable"
                          onClick={connectWalletPressed}
                        >
                          Connect Wallet
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-11">
                <ul className="options_list">
                  <li>
                    <a href="#aboutAndGamification">
                      <div className="media_div">
                        <img src="assets/images/i-icon.png" alt="" />
                      </div>
                      <p>WHAT IS A SUPER BABY ? LEARN MORE...</p>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://opensea.io/collection/super-creators-gen-z"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      <div className="media_div">
                        <img src="assets/images/collection.png" alt="" />
                      </div>
                      <p>VIEW SUPER BABIES COLLECTION ON OPENSEA</p>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="create_baby pt-0">
          <div className="container">
            <div className="heading_block">
              <h2>Create Your Super Baby...</h2>
              <p>
                Select your 5 <span>Gen Z</span> tokens for minting
              </p>
            </div>
            <ul className="baby_list">
              <li
                className={
                  activeDeactiveSuperBabySelected(superBabiesTypes.SPACE)
                    ? "active"
                    : undefined
                }
              >
                <div className="media_div">
                  <img src="assets/images/create-super-baby1.png" alt="" />{" "}
                  <img
                    className="white_images"
                    src="assets/images/create-super-baby-white1.png"
                    alt=""
                  />
                </div>
                <div
                  className="feature_box clickable"
                  onClick={() => {
                    getSuperBabiesToken(superBabiesTypes.SPACE);
                  }}
                >
                  {checkSuperBabySelected(superBabiesTypes.SPACE)}
                </div>
                <span>{superBabiesTypes.SPACE}</span>
              </li>
              <li
                className={
                  activeDeactiveSuperBabySelected(superBabiesTypes.AIR)
                    ? "active"
                    : undefined
                }
              >
                <div className="media_div">
                  <img src="assets/images/create-super-baby2.png" alt="" />{" "}
                  <img
                    className="white_images"
                    src="assets/images/create-super-baby-white2.png"
                    alt=""
                  />{" "}
                </div>
                <div
                  className="feature_box clickable"
                  onClick={() => {
                    getSuperBabiesToken(superBabiesTypes.AIR);
                  }}
                >
                  {checkSuperBabySelected(superBabiesTypes.AIR)}
                </div>
                <span>{superBabiesTypes.AIR}</span>
              </li>
              <li
                className={
                  activeDeactiveSuperBabySelected(superBabiesTypes.WATER)
                    ? "active"
                    : undefined
                }
              >
                <div className="media_div">
                  <img src="assets/images/create-super-baby3.png" alt="" />{" "}
                  <img
                    className="white_images"
                    src="assets/images/create-super-baby-white3.png"
                    alt=""
                  />{" "}
                </div>
                <div
                  className="feature_box clickable"
                  onClick={() => {
                    getSuperBabiesToken(superBabiesTypes.WATER);
                  }}
                >
                  {checkSuperBabySelected(superBabiesTypes.WATER)}
                </div>
                <span>{superBabiesTypes.WATER}</span>
              </li>
              <li
                className={
                  activeDeactiveSuperBabySelected(superBabiesTypes.FIRE)
                    ? "active"
                    : undefined
                }
              >
                <div className="media_div">
                  <img src="assets/images/create-super-baby4.png" alt="" />{" "}
                  <img
                    className="white_images"
                    src="assets/images/create-super-baby-white4.png"
                    alt=""
                  />{" "}
                </div>
                <div
                  className="feature_box clickable"
                  onClick={() => {
                    getSuperBabiesToken(superBabiesTypes.FIRE);
                  }}
                >
                  {checkSuperBabySelected(superBabiesTypes.FIRE)}
                </div>
                <span>{superBabiesTypes.FIRE}</span>
              </li>
              <li
                className={
                  activeDeactiveSuperBabySelected(superBabiesTypes.EARTH)
                    ? "active"
                    : undefined
                }
              >
                <div className="media_div">
                  <img src="assets/images/create-super-baby5.png" alt="" />{" "}
                  <img
                    className="white_images"
                    src="assets/images/create-super-baby-white5.png"
                    alt=""
                  />{" "}
                </div>
                <div
                  className="feature_box clickable"
                  onClick={() => {
                    getSuperBabiesToken(superBabiesTypes.EARTH);
                  }}
                >
                  {checkSuperBabySelected(superBabiesTypes.EARTH)}
                </div>
                <span>{superBabiesTypes.EARTH}</span>
              </li>
            </ul>
            <div className="button_div text-center">
              <MintButton
                type={"button"}
                className={"make_baby" + (!buttonDisabled ? " active" : "")}
                disabled={buttonDisabled}
                onClick={mintSuperBabyNFTPressed}
              >
                Make Super Baby
              </MintButton>
              <p className="mt-3 text-white">
                * Please note that you must be holding Baby tokens for minimum
                90 days to be eligible to mint Superbabies *
              </p>
            </div>
          </div>
        </section>
        <section className="minted_super-babies">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-12 text-center">
                <div className="heading_block">
                  <h2>Minted Super Babies</h2>
                </div>
              </div>
              {showMintedSuperBabies()}
            </div>
          </div>
        </section>
        <section className="about-gamification pt-0">
          <div className="container">
            <div className="row flex-row-reverse justify-content-between align-items-center">
              <div className="col-lg-4">
                <div className="media_div">
                  <img
                    src="assets/images/about-gamification.png"
                    alt="about-gamification"
                  />
                </div>
              </div>
              <div className="col-lg-7" id="aboutAndGamification">
                <div className="heading_block">
                  <h2>About &amp; Gamification </h2>
                  <p>
                    A Super baby is a rare being that is only formed when five
                    SuperCreators Jr’s (Juniors) combine their elemental powers.
                  </p>
                  <span>
                    To Manifest a Super Baby, collect a set of five Juniors with
                    each element trait (Earth, Water, Fire, Air & Space) and
                    allow them to fuse their energies together for 90 days
                  </span>
                  <span>
                    The same set of Five Juniors will not be able to summon
                    another Super Baby, as their energies are intermingled with
                    the Super Baby they have called forth onto Earth.
                  </span>
                  <span>
                    Only 55 SUPER BABIES can be summoned onto Earth to aid in
                    the elevation of humanity.
                  </span>
                  <span>
                    If you are lucky enough to assemble a full set of 5 elements
                    then you might be able to summon a Super Baby that will
                    unlock incredible benefits to the holder (to be revealed
                    soon!).
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="lore pt-0">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-lg-4">
                <div className="media_div">
                  <img src="assets/images/lore.png" alt="" />
                </div>
              </div>
              <div className="col-lg-7">
                <div className="heading_block">
                  <h2>Lore</h2>
                  <p>
                    A “Super Baby” is Super because, it possesses the power of
                    all five elements from the five SuperCreators Jr’s in a
                    single vessel. What are the elements?
                  </p>
                </div>
                <ul className="creator mb-5">
                  <li>
                    <i>&nbsp;</i>
                    <span>Space</span>
                    <p>
                      Space was created first. It holds everything. The entire
                      Universe is nothing but, a never ending expanse of space.
                      There is space within, outside and all around us.
                    </p>
                  </li>
                  <li>
                    <i>&nbsp;</i>
                    <span>Air</span>
                    <p>
                      Then came the Air, the life force. Everything that is
                      alive is because of this life force. Oneness with our
                      breath is oneness with divinity.{" "}
                    </p>
                  </li>
                  <li>
                    <i>&nbsp;</i>
                    <span>Fire</span>
                    <p>
                      Fire represents our energy, action, activity and passion.
                      Things take form in our life because of the fire in us
                      that drives us forward.
                    </p>
                  </li>
                  <li>
                    <i>&nbsp;</i>
                    <span>Water</span>
                    <p>
                      Water represents being in flow and connecting with
                      everything. It helps keep everything together.{" "}
                    </p>
                  </li>
                  <li>
                    <i>&nbsp;</i>
                    <span>Earth</span>
                    <p>
                      Earth represents everything that is in a solid state,
                      including us. We are made up of earth and we will return
                      to earth.{" "}
                    </p>
                  </li>
                </ul>
                <p>When these elements came together, life is created.</p>
                <p>
                  Everything in the Cosmos, Everything within us are these Five
                  Great Elements.
                </p>
              </div>
              <div className="col-lg-12">
                <ul className="options_list justify-content-center">
                  <li>
                    <a
                      href="https://opensea.io/collection/super-creators-gen-z"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      <div className="media_div">
                        <img src="assets/images/collection.png" alt="" />
                      </div>
                      <p>VIEW SUPER BABIES COLLECTION ON OPENSEA</p>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="faq section">
          <div className="container">
            <h2>FAQ’s</h2>
            {
              <div className="row">
                <div className="container">
                  <div
                    className="accordion"
                    id="accordionPanelsStayOpenExample"
                  >
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq1"
                          aria-expanded="true"
                        >
                          Why Don’t I see my SuperCreator Jr token?
                        </button>
                      </h2>
                      <div
                        id="faq1"
                        className="accordion-collapse collapse show"
                      >
                        <div className="accordion-body">
                          <ul>
                            <li>
                              Token data is refreshed at the end of each month,
                              so if you’ve recently purchased a SuperCreators Jr
                              intending to mint a Super Baby, then it will not
                              appear until the data refresh has happened at the
                              end of each month. Please be patient and refrain
                              from raising a ticket to our team.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq2"
                          aria-expanded="false"
                        >
                          How Many Super Babies are there?
                        </button>
                      </h2>
                      <div id="faq2" className="accordion-collapse collapse">
                        <div className="accordion-body">
                          <ul>
                            <li>
                              There are only and will only ever be 55 Super
                              Babies,making them ULTRA rare!{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq3"
                          aria-expanded="false"
                        >
                          What are the Special Benefits of Holding a Super Baby?
                        </button>
                      </h2>
                      <div id="faq3" className="accordion-collapse collapse">
                        <div className="accordion-body">
                          <ul>
                            <li>
                              If you hold a Super Baby With a set of 5 Super
                              Creator Jr’s with each of the 5 elements (Air,
                              Fire, Water, Earth, Space), then you’ll be able to
                              unlock tier 4 access of the Academi! Submit a
                              ticket in our Discord server in the
                              #Support-Ticket-Bot Channel to find out how to
                              claim this premium access.
                            </li>
                            <li>
                              Some additional incredible benefits will be
                              announced in the near future!
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq4"
                          aria-expanded="false"
                        >
                          Why Should I Mint or Own Super Baby?
                        </button>
                      </h2>
                      <div id="faq4" className="accordion-collapse collapse">
                        <div className="accordion-body">
                          <ul>
                            <li>
                              There will only ever be 55 Super Babies. EVER!
                              This makes them ultra rare and scarce.
                            </li>
                            <li>
                              Not only will you be owning something extremely
                              uncommon, but it will give you premium to our
                              Academi, where you’ll gain access to thousands of
                              dollars worth of training - For free!
                            </li>
                            <li>
                              There will also be some future benefits to holding
                              these tokens that will be revealed in the near
                              future. Stay tuned!
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq5"
                          aria-expanded="false"
                        >
                          How Do I Mint a Super Baby?
                        </button>
                      </h2>
                      <div id="faq5" className="accordion-collapse collapse">
                        <div className="accordion-body">
                          <ul>
                            <li>
                              Collect a set of 5 SuperCreator Jr’s with each of
                              the five elements: Air, Earth, Fire, Water, Space
                            </li>
                            <li>Hold them in your wallet for 90 days</li>
                            <li>
                              If you haven’t minted a Super Baby from this set
                              of Jr’s then you will be able to mint a Super Baby
                              on this page!
                            </li>
                          </ul>
                          <p>
                            Please note: If all 55 Super Babies have been
                            minted, then you will not be able to mint a Super
                            Baby
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq6"
                          aria-expanded="false"
                        >
                          How Can I Buy a Super Baby?
                        </button>
                      </h2>
                      <div id="faq6" className="accordion-collapse collapse">
                        <div className="accordion-body">
                          <ul>
                            <li>
                              You can buy a Super Baby here:{" "}
                              <a
                                href="https://opensea.io/collection/super-creators-gen-z"
                                target={"_blank"}
                                rel={"noreferrer"}
                              >
                                SuperCreators - Gen Z - Collection | OpenSea
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq7"
                          aria-expanded="false"
                        >
                          What collection are the SuperCreators Jr’s a part of?
                        </button>
                      </h2>
                      <div id="faq7" className="accordion-collapse collapse">
                        <div className="accordion-body">
                          <ul>
                            <li>
                              SuperCreators Jr’s are a part of the SuperCreators
                              - Gen Z Collection. Check it out here{" "}
                              <a
                                href="https://opensea.io/collection/super-creators-gen-z"
                                target={"_blank"}
                                rel={"noreferrer"}
                              >
                                SuperCreators - Gen Z - Collection | OpenSea
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq8"
                          aria-expanded="false"
                        >
                          What collection are the Super Babies a part of?
                        </button>
                      </h2>
                      <div id="faq8" className="accordion-collapse collapse">
                        <div className="accordion-body">
                          <ul>
                            <li>
                              Super Babies are a part of the SuperCreators - Gen
                              Z Collection. Check it out here{" "}
                              <a
                                href="https://opensea.io/collection/super-creators-gen-z"
                                target={"_blank"}
                                rel={"noreferrer"}
                              >
                                SuperCreators - Gen Z - Collection | OpenSea
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq9"
                          aria-expanded="false"
                        >
                          Can I mint a Second Super Baby?
                        </button>
                      </h2>
                      <div id="faq9" className="accordion-collapse collapse">
                        <div className="accordion-body">
                          <ul>
                            <li>
                              After you have minted 1 Super Baby with a set of 5
                              Jr’s,you must wait 180 days until you can mint a
                              further Super Baby.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq10"
                          aria-expanded="false"
                        >
                          Can I still Mint a Super Baby?
                        </button>
                      </h2>
                      <div id="faq10" className="accordion-collapse collapse">
                        <div className="accordion-body">
                          <ul>
                            <li>
                              You can mint Super Babies as long as all 55 Super
                              Babies haven’t been minted!
                              <br /> Check here:{" "}
                              <a
                                href="https://opensea.io/collection/super-creators-gen-z"
                                target={"_blank"}
                                rel={"noreferrer"}
                              >
                                SuperCreators - Gen Z - Collection | OpenSea
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq11"
                          aria-expanded="false"
                        >
                          Why Can't I Mint A Super Baby?
                        </button>
                      </h2>
                      <div id="faq11" className="accordion-collapse collapse">
                        <div className="accordion-body">
                          <p className="mb-1">
                            There may be a number of reasons:{" "}
                          </p>
                          <ul>
                            <li>All 55 Super Babies have been minted</li>
                            <li>
                              You don't have a set of 5 SuperCreator Jr Tokens
                              that have been held in your wallet for over 90
                              days
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </section>
        {/* Modals */}
        {modal.superBabyModal && (
          <GlobalModal
            id={"super_baby_modal"}
            className={"superCreatorsModal"}
            isOpen={modal.superBabyModal}
            isCloseButtonDisplay={true}
            isHeaderDisplay={true}
            modalTitle={"Select Your Gen Z"}
            dialogClassName={"modal-lg modal-dialog-centered"}
            onModalClose={(e) => handleModalClose("super_baby_modal")}
          >
            <ul className="genlist">
              {filteredSuperBabies.length > 0 &&
                filteredSuperBabies.map((superBaby, idx) => {
                  return (
                    <Fragment key={`superBaby-${idx}`}>
                      {superBaby.isEligibleForMint ? (
                        <li
                          className="active clickable"
                          onClick={() => {
                            setSuperBabiesGroup(
                              superBaby,
                              superBaby?.type.toUpperCase()
                            );
                          }}
                        >
                          <div className="media_div">
                            {" "}
                            <img src={superBaby.image} alt="" />{" "}
                          </div>{" "}
                          <span>{superBaby?.type}</span>{" "}
                        </li>
                      ) : (
                        <li>
                          <div className="media_div">
                            {" "}
                            <img src={superBaby.image} alt="" />{" "}
                            <div className="modal-overlay">
                              <span>
                                {superBaby.remainingDays}
                                <br />
                                days
                                <br />
                                remaining
                              </span>
                            </div>
                          </div>{" "}
                          <span>{superBaby?.type}</span>{" "}
                        </li>
                      )}
                    </Fragment>
                  );
                })}
            </ul>
          </GlobalModal>
        )}

        {modal.videoModal && (
          <GlobalModal
            id={"video-modal"}
            isOpen={modal.videoModal}
            isCloseButtonDisplay={displayCloseButton}
            isHeaderDisplay={true}
            modalTitle={""}
            dialogClassName={"modal-lg modal-dialog-centered"}
            modalId={"video"}
            onModalClose={(e) => handleModalClose("video_modal")}
            backdrop="static"
            keyboard={false}
          >
            {/* <section className="insert_video p-0">
              <div> */}
            <video
              className="video-modal"
              width="100%"
              //height="350"
              controls
              playsInline
              muted
              autoPlay={true}
              id={"videoId"}
              ref={videoRef}
              onEnded={() => {
                setDisplayCloseButton(true);
              }}
            >
              <source
                src="assets/images/super_baby_mint_animation.mp4"
                type="video/mp4"
              />
            </video>
            {/* </div>
            </section> */}
          </GlobalModal>
        )}
      </div>
      <CommonLoader />
    </>
  );
};

export default SuperBabyMint;
